import { SingleSystemSettingsTab } from '@/pages/SystemSettings/enum';
import { getValueFromLocalStorage } from '@shared/services/storage';
import { BreadcrumbHandle } from './types';

const SYSTEMS_PATH = '/systems';
const SYSTEM_GROUPS_PATH = '/system-groups';

export const getSystemStatusCrumbs: BreadcrumbHandle['crumb'] = ({ pathname, data, intl }) => {
  const pathSegments = pathname.split('/').filter(Boolean);
  const lastPathSegment = pathSegments[pathSegments.length - 1];
  const selectedTab = (Object.values(SingleSystemSettingsTab) as string[]).includes(lastPathSegment)
    ? (lastPathSegment as SingleSystemSettingsTab)
    : SingleSystemSettingsTab.Status;
  const breadcrumbData =
    (data as { selectedSystem?: { name?: string }; ancestors?: { id: string; name: string }[] } | undefined) ?? {};

  const systemName = breadcrumbData.selectedSystem?.name || 'System';
  const ancestors = Array.isArray(breadcrumbData.ancestors) ? breadcrumbData.ancestors : [];

  const groupCrumbs = ancestors.map((group, index) => {
    const pathSegments = ancestors
      .slice(0, index + 1)
      .map(({ id }) => id)
      .join('/');

    return {
      title: group.name,
      path: `${SYSTEM_GROUPS_PATH}/${pathSegments}`,
    };
  });

  const systemsTitle = intl.formatMessage({ id: 'menu.items.systems', defaultMessage: 'Systems' });
  const rootCrumbs = groupCrumbs.length
    ? [{ title: systemsTitle, path: SYSTEMS_PATH }, ...groupCrumbs]
    : [{ title: systemsTitle, path: SYSTEMS_PATH }];

  if (selectedTab === SingleSystemSettingsTab.Status) {
    return [...rootCrumbs, { title: systemName }];
  }

  return [...rootCrumbs];
};

export const getSystemMenuCrumbs: BreadcrumbHandle['crumb'] = ({ pathname, intl }) => {
  const parts = pathname.split('/');
  const menuIndex = parts.indexOf(SingleSystemSettingsTab.Menu);
  if (menuIndex === -1) return null;

  const menuBasePath = parts.slice(0, menuIndex + 1).join('/');
  const ids = parts.slice(menuIndex + 1).filter(Boolean);
  const mainMenuTitle = intl.formatMessage({ id: 'label.main-menu', defaultMessage: 'Main menu' });

  if (ids.length === 0) return { title: mainMenuTitle, path: menuBasePath };

  const storedCrumbs: Array<{ id: string; title: string }> = getValueFromLocalStorage('DEVICE_MENU_BREADCRUMBS') ?? [];
  const titleMap = new Map(storedCrumbs.map(c => [c.id, c.title]));

  return [
    { title: mainMenuTitle, path: menuBasePath },
    ...ids.map((id, i) => ({
      title: titleMap.get(id) ?? `Menu ${id}`,
      path: parts.slice(0, menuIndex + 1 + i + 1).join('/'),
    })),
  ];
};
